import { CIcon } from '~/icons/types'

export const ciCabinBoat: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.337 9.974a.5.5 0 0 0-.436-.256h-4.235C18.313 7.474 15.621 6 13.095 6h-9.8a.5.5 0 1 0 0 1h2.044l-1.6 3.973H.501a.5.5 0 0 0-.5.5v5.948a.5.5 0 0 0 .5.5h15.7a4.61 4.61 0 0 0 3.906-2.187l3.22-5.254a.5.5 0 0 0 .01-.506ZM11.69 7h1.4c1.984 0 4.175 1.093 4.555 2.718h-5.96L11.69 7ZM6.416 7h4.274v2.909l-2.127 1.064H4.821L6.416 7Zm12.837 8.211a3.601 3.601 0 0 1-3.052 1.71h-15.2v-4.948h7.68a.512.512 0 0 0 .224-.053l2.4-1.2h10.7l-2.752 4.491Z'
    },
    {
      d:
        'M12.165 12.23a.775.775 0 1 0 0 1.55.775.775 0 0 0 0-1.55Zm2.743 1.548a.774.774 0 1 0 0-1.548.774.774 0 0 0 0 1.548Zm2.743 0a.774.774 0 1 0 0-1.548.774.774 0 0 0 0 1.548Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'cabin-boat',
  type: 'thin'
}
